import React from 'react';
import { FiSettings } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import './SettingsAppearance.css';

export default function SettingsEmptyState({ title, msg, children }) {
    const { i18n } = useTranslation('global');
    const english = (i18n.resolvedLanguage || i18n.language || 'ar').startsWith('en');
    return <section className="settings-empty-page">
        {title && <h2>{title}</h2>}
        <div className="settings-empty-message" role="status">
            <FiSettings size={30} aria-hidden="true" />
            <p>{msg || (english ? 'No settings available to edit at the moment.' : 'لا توجد إعدادات قابلة للتعديل حاليًا.')}</p>
            {children}
        </div>
    </section>;
}
